import React, { useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_RATE_PRACT_HELP = `
  <div>
    <p>Here you as the practitioner can give your impression of how successful the client was in using the access method during this Test-drive.      
    </p>
    <p>
    You’ll be able to enter additional observations and feedback in the next steps.  
    On this page, we are just trying to keep it simple and rate one important aspect of how things went in the Test-drive. 
    </p>  
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeTestDrivePractitionerRating: PropTypes.string,
  onChangeActiveTestDrivePractitionerRating: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeTestDrivePractitionerRating: '',
};

//content sub-component with unique content for this page
function TestDriveRatePractitionerContent(props) {
  // const firstName = props.firstName;
  const activeTestDrivePractitionerRating = props.activeTestDrivePractitionerRating;
  const onChangeActiveTestDrivePractitionerRating = props.onChangeActiveTestDrivePractitionerRating;

  const ratingBtns = [
    {
      value: 'never',
      label: `Never`,
      moreInfo: ''
    },
    {
      value: 'rarely',
      label: `Rarely`,
      moreInfo: '(about 25% of the time)'
    },
    {
      value: 'sometimes',
      label: `Sometimes`,
      moreInfo: '(about 50% of the time)'
    },
    {
      value: 'often',
      label: `Often`,
      moreInfo: '(about 75% of the time)'
    },
    {
      value: 'always',
      label: `Always`,
      moreInfo: ''
    }
  ];
  return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Success rating:</legend>
        {ratingBtns.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={activeTestDrivePractitionerRating===btn.value}
              onChange={onChangeActiveTestDrivePractitionerRating}
              name="practitioner-rating"
              type="radio"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
        )}
      </FormGroup>
    </Form>
    <p>
      Next, we'll look at issues you may have observed during the Test-drive.
    </p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveRatePractitioner(props) {
  const firstName = props.firstName;
  const activeTestDrivePractitionerRating = props.activeTestDrivePractitionerRating;
  const onChangeActiveTestDrivePractitionerRating = props.onChangeActiveTestDrivePractitionerRating;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-smile-o",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `From your perspective, how did that Test-drive go?`,
    subTitle: `First, about how successfully was ${firstName} able to control the access method during this Test-drive?`,
    learnMore: {linkText: "Learn More about practitioner's rating for a Test-drive",
                title: "Practitioner's rating for a Test-drive",
                content: TD_RATE_PRACT_HELP
                },
    nextRoute: "",
    sidebar: false
  }

  console.log("Rendering TestDriveRatePractitioner, practitionerRating is: " + activeTestDrivePractitionerRating);

  useEffect(() => {
    return () => {
      saveFormData();
    }
  }, [saveFormData])

  //there is no useEffect() method because we aren't saving anything here to global Sesion
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveRatePractitionerContent 
          firstName={firstName}
          activeTestDrivePractitionerRating={activeTestDrivePractitionerRating}
          onChangeActiveTestDrivePractitionerRating={onChangeActiveTestDrivePractitionerRating}
        />
      }
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveRatePractitioner.propTypes = propTypes;
TestDriveRatePractitioner.defaultProps = defaultProps;

export default TestDriveRatePractitioner;